module.exports = __webpack_public_path__ + "img/Facebook.71dc5fad.svg";